import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { CampaignType, SaveCampaignBody } from 'api/types/campaign'
import { UploadFile } from 'pages/Admin/Product'

// Campaign API service class
class Campaign {
  // fetch list of campaign categories
  async getCampaignList(): Promise<CampaignType[] | AxiosError | Error> {
    const url = APIRoutes.campaign.getCampaignList
    return ApiProvider.getRequest(url) as Promise<
      CampaignType[] | AxiosError | Error
    >
  }

  // fetch a single campaign by id
  async getCampaign({ id }: { id: string }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.campaign.getCampaign}?id=${id}`
    return ApiProvider.getRequest(url) as Promise<any | AxiosError | Error>
  }

  // delete a campaign
  async deleteCampaign({
    id,
  }: {
    id: string
  }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.campaign.deleteCampaign}?id=${id}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }

  // create or update a campaign
  async saveCampaign({
    id,
    title,
    content,
    description,
    label,
    link,
    createdDate,
    expirationDate,
    active,
  }: SaveCampaignBody): Promise<string | AxiosError | Error> {
    const url = APIRoutes.campaign.saveCampaign
    const body = new FormData()
    if (id) body.append('id', id)
    if (title) body.append('title', title)
    if (content) body.append('content', content)
    if (description) body.append('description', description)
    if (label) body.append('label', label)
    if (link) body.append('link', link)
    if (createdDate) body.append('createdDate', createdDate)
    if (expirationDate) body.append('expirationDate', expirationDate)
    body.append('active', active ? 'true' : 'false')

    return ApiProvider.postRequest(url, body, true) as Promise<
      string | AxiosError | Error
    >
  }

  // add portal campaign files
  async addPortalCampaignFiles({
    id,
    file,
  }: {
    id: string
    file: UploadFile
  }): Promise<string | AxiosError | Error> {
    const url = APIRoutes.campaign.addCampaignFiles
    const formData = new FormData()
    formData.append('id', id)
    formData.append(`files[0].File`, file.file)
    formData.append(`files[0].label`, file.label)
    return ApiProvider.postRequest(url, formData, true) as Promise<
      string | AxiosError | Error
    >
  }

  // remove a portal campaign file
  async removePortalCampaignFile({
    campaignid,
    fileId,
  }: {
    campaignid: string
    fileId: string
  }): Promise<any | AxiosError | Error> {
    const url = `${APIRoutes.campaign.removeCampaignFile}?campaignid=${campaignid}&fileId=${fileId}`
    return ApiProvider.deleteRequest(url) as Promise<any | AxiosError | Error>
  }
}

export const campaignService = new Campaign()
